const businessErrors = {
  name: "El campo nombre es obligatorio.",
  address: "El campo dirección es obligatorio.",
  keywords: "Las palabras clave son obligatorias.",
  phoneNumbers:
    "El número de teléfono ingresado no es válido. En caso de contener más de uno, deben separarse por comas.",
  whatsApp:
    "El número de WhatsApp ingresado no es válido. En caso de contener más de uno, deben separarse por comas.",
  delivery: "El campo delivery es obligatorio.",
  location: "La localización ingresada no es correcta.",
  category: "El campo catergoria es obligatorio.",
  ownerDni: "El campo DNI del propietario es obligatorio.",
  schedule: "La hora ingresada es incorrecta.",
};

export { businessErrors };

const usersErrors = {
  role:
    "Solo puede modificar el rol mientras los valores sean 'Ciudadano' 'Pendiente de Verificacion' ó 'Voluntario'",
};

export { usersErrors };

const notificationsErrors = {
  title: "Debe insertar un titulo. ",
  body: "Debe insertar el texto de la notificación. ",
  category: "Debe seleccionar al menos una categoria. ",
  image: "El peso de la imagen no puede ser superior a 1 MB. ",
  server: "Ocurrió un problema. Por favor, intentelo más tarde.",
  ok: "La notificación fue enviada con éxito.",
  link: "El link ingresado no tiene un formato válido.",
};

export { notificationsErrors };

const emergencyErrors = {
  server: "Ocurrió un problema. Por favor, intentelo más tarde.",
};

export { emergencyErrors };

const generalErrors = {
  data:
    "Ocurrió un problema, revise los datos ingresados y vuelva a intentarlo nuevamente.",
  server:
    "Ocurrió un problema con el servidor. Por favor, intentelo más tarde.",
};

export { generalErrors };

const callsErrors = {
  type: "Formato del archivo: desconocido.",
  size: "El peso del archivo no puede ser superior a 2 MB.",
  server: "Ocurrió un problema. Por favor, intentelo más tarde.",
  resultEmpty: "No se adjuntaron archivos al resultado.",
  extensionBeforeCallEnd: "La fecha de prórroga no puede ser previa al fin de la convocatoria.",
  extensionBeforeCurrent: "La fecha de prórroga no puede ser previa a la fecha de prórroga actual.",
  duplicatedApplication: "Ya tienes una postulación a esta convocatoria. Revisa en la sección 'Mis postulaciones'.",
};

export { callsErrors };

